import { SanitizationOption } from 'app/utils/htmlSanitizer/types';

import { SANITIZE_PROFILE_DEFAULT } from './default';

export const SANITIZE_PROFILE_MESSAGING: SanitizationOption = {
  allowedTags: ['br', 'placeholderp', 'em', 'i', 'b', 'strong', 'a'],
  transformTags: { p: 'placeholderp' },
  allowedAttributes: {
    '*': ['dir'],
    em: ['class'],
    a: ['href', 'target', 'rel'],
  },
  allowedClasses: {
    em: ['highlight'],
  },
  allowedSchemes: SANITIZE_PROFILE_DEFAULT.allowedSchemes,
};
